import { baseProduct } from "./"
export default {
	name: "Lorem ipsum",
	description: "",
	descriptionShort: "",
	videos: { items: [] },
	subscriptions: [],
	products: [baseProduct, baseProduct, baseProduct, baseProduct]
}
